import { UserRole } from '../../enums/user/user-role.enum';

export const UserRoleTranslationMapper = new Map([
  [UserRole.User, 'USER_ROLES.USER'],
  [UserRole.Admin, 'USER_ROLES.ADMIN'],
  [UserRole.Owner, 'USER_ROLES.OWNER'],
]);
